import { getOrganizationMembersList,getOrganizationMembersShortList, } from 'custom_modules/Projects/projectsActions';
import { connect } from 'react-redux';

// Actions
import { getOfficesShortList } from '../Offices/officesActions';
import { getOfficeDetails } from '../OfficesNew/officesActions';
// Component
import ClockInOut from './ClockInOut';
import {
  exportClockInOutList,
  getAllMemberLastClockInOut,
  getClockInOutList,
  getGroupedClockInOutList,
} from './clockInOutActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  clockInOutList: state.clockInOut.clockInOutList,
  isLoading: state.clockInOut.isLoading,

  officesShortList: state.office.officesShortList,

  onlineMembers: state.clockInOut.onlineMembers,

  // pagination
  clockInOutListCount: state.clockInOut.clockInOutListCount,
  clockInOutPageSize: state.clockInOut.clockInOutPageSize,
  organizationMembersList: state.project.orgMembersList,

  officeDetails: state.office.officeDetails,

  //member short list
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getClockInOutList: payload => dispatch(getClockInOutList(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  exportClockInOutList: payload => dispatch(exportClockInOutList(payload)),
  getOrganizationMembersList: details =>
    dispatch(getOrganizationMembersList({ ...details })),
  getAllMemberLastClockInOut: details =>
    dispatch(getAllMemberLastClockInOut({ ...details })),
  getOfficeDetails: details => dispatch(getOfficeDetails({ ...details })),
  getOrganizationMembersShortList: params =>
      dispatch(getOrganizationMembersShortList(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(ClockInOut);
